<template>
  <div>
    <div class="header">
      <Header></Header>
    </div>
    <el-row type="flex" justify="center" style="margin-top: 15px">
      <el-col :span="18">
        <el-container>
          <el-aside width="200px">
            <el-menu
                style="height: 100%;"
                :default-active="paper"
                router
                class="el-menu-vertical-demo"
            >
              <template>
                <div style="height: 30px;width: 100%;border-bottom: 1px solid #d7dae2" ></div>
              </template>
              <el-menu-item :index="sign">
                <i class="el-icon-date"></i>
                <span slot="title">registration record</span>
              </el-menu-item>
<!--              <el-menu-item index="/person/hotel">-->
<!--                <i class="el-icon-office-building"></i>-->
<!--                <span slot="title">Hotel reservation</span>-->
<!--              </el-menu-item>-->
              <el-menu-item :index="paper">
                <i class="el-icon-reading"></i>
                <span slot="title">The paper overview</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main>
            <router-view/>
          </el-main>
        </el-container>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
name: "person",
  data(){
    return{
      id:0,
      sign:"",
      paper:"",
    }
  },
  beforeMount() {
    this.id = localStorage.getItem("id")
    console.log(this.id)
    this.sign = `/person/sign?id=${this.id}`
    this.paper = `/person/paper?id=${this.id}`
  }
}
</script>

<style scoped lang="less">
//.head{
//  background-color:white;
//  color: #333;
//  text-align: center;
//  line-height: 100px;
//  //width: 1535px;
//  height: 100px;
//}
.el-aside {
  color: #333;
  text-align: center;
  height: 580px;
}

.el-main {
  background-color: white;
  //background-color:#D3DCE6;
  color: #333;
  text-align: center;
  padding: 0;
}
.el-menu{
  //background-color: #D3DCE6 !important;
  background-color: white;

}
.el-menu-item.is-active{
  //background-color: white;
}
.el-tabs__nav-wrap{
  padding: 20px;
}
</style>
